var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWizardH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1037_",
    d: "M13,16.28c1.52,0,2.79-1.05,3.16-2.45h1.74c0.37,1.41,1.64,2.45,3.16,2.45s2.79-1.05,3.16-2.45H26V12.2 h-1.77c-0.36-1.42-1.64-2.48-3.17-2.48s-2.81,1.06-3.17,2.48h-1.72c-0.36-1.42-1.64-2.48-3.17-2.48c-1.53,0-2.81,1.06-3.17,2.48 H8.15c-0.36-1.42-1.64-2.48-3.17-2.48s-2.81,1.06-3.17,2.48H0l0,1.62h1.82c0.37,1.41,1.64,2.45,3.16,2.45s2.79-1.05,3.16-2.45h1.7 C10.21,15.23,11.48,16.28,13,16.28z M21.06,11.34c0.91,0,1.66,0.74,1.66,1.66s-0.74,1.66-1.66,1.66s-1.66-0.74-1.66-1.66 S20.15,11.34,21.06,11.34z M13,11.34c0.91,0,1.66,0.74,1.66,1.66s-0.74,1.66-1.66,1.66s-1.65-0.74-1.65-1.66S12.09,11.34,13,11.34z  M4.98,14.66c-0.91,0-1.66-0.74-1.66-1.66s0.74-1.66,1.66-1.66S6.63,12.09,6.63,13S5.89,14.66,4.98,14.66z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardH);
export default __webpack_public_path__ + "static/media/WizardH.90749269364a09889f976e525c6036bf.svg";
export { ForwardRef as ReactComponent };